import { render, staticRenderFns } from "./Depreciation.vue?vue&type=template&id=b0fcbe9e&scoped=true&"
import script from "./Depreciation.vue?vue&type=script&lang=js&"
export * from "./Depreciation.vue?vue&type=script&lang=js&"
import style0 from "./Depreciation.vue?vue&type=style&index=0&id=b0fcbe9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fcbe9e",
  null
  
)

export default component.exports